import axios from "axios";
import { baseUrl, buildQuery,  } from "../config/api-config";
export const hhsFile= "https://erp-hhs.vastedge.com/api"
export function getTransactionInvoiceDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getInvoiceDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}



export function getTransactionInvoiceItemDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/invoiceItemDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionQuoteEstimateItemDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/quoteestimateitemdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getTransactioninvoiceAccounting(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/accounting${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionMessage(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/communicationMessage${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getTransactionFiles(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/transactionMessagefile${q}`, {
    headers: {
      authorization: token,
    },
  });
}
// export function getTransactionDownloadfile( query,options) {
//   // const q = buildQuery(query);
//   return axios.post(`${"https://hhs-files.vastedge.com/api"}/transactionDownloadfile`, data, {
//    options,
//     responseType: "blob",
//   });
// }

export function getTransactionDownloadfile(options,query) {
  const q = buildQuery(query);
  return axios.get(
    `${hhsFile}/transactionDownloadfile${q}`,
    options
    //    {
    //     headers: {
    //       authorization: token,
    //     },
    // responseType: "blob",
    //   }
  );
}

export function getTransactionCreditCardRefundItemDetail(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/creditcardrefunditemdetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}